import React from 'react'
import { ImgIcon } from 'src/components/ImgIcon'
import movimentationIconPath from '../images/movement.png'
import weighingIconPath from '../images/weighing.png'

export { default as more } from './more.png'
export { default as properties } from './properties.png'
export { default as chevronLeft } from './chevron-left.png'
export { default as chevronRight } from './chevron-right.png'
export { default as ellipsis } from './ellipsis.png'
export { default as loginBackground } from './loginBackground.png'
export { default as emoticonSad } from './emoticonSad.png'
export { default as emoticonBad } from './emoticonBad.png'
export { default as emoticonHappy } from './emoticonHappy.png'
export { default as emoticonHeart } from './emoticonHeart.png'
export { default as wheat } from './wheat.png'
export { default as pasture } from './pasture.png'
export { default as tag } from './tag.png'
export { default as tip } from './tip.png'
export { default as lupa } from './lupa.png'
export { default as deleteIcon } from './delete-icon.png'
export { default as fileDownload } from './file-download.png'
export { default as settings } from './settings.png'

export const MovimentationIcon = (props) => (
  <ImgIcon src={movimentationIconPath} alt='icone de movimentação' {...props} />
)
export const WeighingIcon = (props) => <ImgIcon src={weighingIconPath} alt='icone de pesagem' {...props} />
